import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { typedMemo } from '@utils';
import React, { useEffect, useRef, useState } from 'react';

export interface TabItem {
  label: string;
  children: React.ReactNode;
}

interface TabGroupProps {
  tabs: TabItem[];
  defaultValue?: number;
}

export const TabGroup = typedMemo(
  ({ tabs, defaultValue = 0 }: Readonly<TabGroupProps>) => {
    const [tabValue, setTabValue] = useState(defaultValue);
    const refs = useRef<(HTMLDivElement | null)[]>([]);

    useEffect(() => {
      tabs.forEach((_, index) => {
        const panel = refs.current[index];
        if (panel) {
          const hasAgGrid = !!panel.querySelector('.ag-theme-brz');
          panel.style.height = hasAgGrid ? 'calc(100% - 20px)' : 'unset';
        }
      });
    }, [tabs]);

    return (
      <TabContext value={tabValue}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList
            onChange={(_, newValue) => setTabValue(newValue)}
            variant="scrollable"
            scrollButtons="auto"
          >
            {tabs.map((tab) => (
              <Tab key={tab.label} label={tab.label} />
            ))}
          </TabList>
        </Box>

        <Box sx={{ flex: 1, overflow: 'auto' }}>
          {tabs.map((tab, index) => (
            <TabPanel
              value={index}
              key={tab.label}
              keepMounted={true}
              sx={{ height: '100%' }}
              ref={(el: HTMLDivElement | null) => {
                refs.current[index] = el;
              }}
            >
              <Box sx={{ height: '100%' }}>{tab.children}</Box>
            </TabPanel>
          ))}
        </Box>
      </TabContext>
    );
  },
);
